module.exports = __webpack_public_path__ + "assets/certificate_pdf/ssa_112_6.6e7320c2.pdf";